import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ComboRelatorReuniao } from 'src/app/core/combo-relator-reuniao';
import { ReuniaoService } from 'src/app/services/reuniao/reuniao.service';


@Component({
  selector: 'combo-pesquisa-relator-reuniao',
  templateUrl: './combo-pesquisa-relator-reuniao.component.html',
  styleUrls: ['./combo-pesquisa-relator-reuniao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboPesquisaRelatorReuniaoComponent implements OnInit {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label;
  @Input() campoPesquisavel = 'nome';
  @Input() fxFlexOffset = "20px";

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor(private reuniaoService: ReuniaoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    setTimeout(() => {
      let $_evento;
      
      $_evento = this.reuniaoService.getAllRelatoresByCombo();  

      $_evento.subscribe((reunioes: ComboRelatorReuniao[]) => {
        this.dados = reunioes;
        this.preencherCombo();

        this.dados.forEach(a => {
          a.nome = a.nome;
        } );

        
        this.dados.sort((a, b) => {
          if (a.nome > b.nome) { return 1; }
          return 0;
        });
      });

    }, 0);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
      this.preencherCombo();
    }
  }

  private preencherCombo() {
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }
}
